// Arabische teksten van de to-do's op het bord (zie todo.nl.ts); het bord zet ze in RTL.
export const todoAr = {
    title: 'مهام لاحقة',
    from: 'من {name}',
    all: 'كل المهام اللاحقة ({count})',
    sheetTitle: 'مهام {name} اللاحقة',
    due: 'قبل {date}',
    empty: 'لا شيء متبقٍ',
    done: 'تم',
    everyone: 'الكل',
    filterOpen: 'مفتوحة',
    filterDone: 'منجزة',
    filterAll: 'الكل',
    doneSection: 'منجزة ({n})',
    doneBy: '{name} · {when}',
    forWho: 'لـ {name}',
    created: 'أُضيفت في {date}',
    important: 'مهم',
    add: 'إضافة مهمة لاحقة',
    noDescription: 'بلا شرح',
    emptyDone: 'لم يُنجز شيء بعد هذا الأسبوع',
    assign: 'إسناد إلى…',
    assignTitle: 'إسناد إلى',
    assignSave: 'إسناد',
    assigned: 'تم الإسناد',
    assignFailed: 'تعذّر الإسناد',
};
//# sourceMappingURL=todo.ar.js.map